import { useSafeAreaInsets } from "react-native-safe-area-context"
import { Platform, useWindowDimensions } from "react-native"

interface DeviceAttributes {
  hasNotch: boolean
  isLargeScreen: boolean
  isIos: boolean
  isAndroid: boolean
  isWeb: boolean
  isSmallScreen: boolean
  screenWidth: number
  screenHeight: number
}

function useDeviceAttributes(): DeviceAttributes {
  const insets = useSafeAreaInsets()
  const { width, height } = useWindowDimensions()

  // Check for notch only on iOS devices
  const hasNotch = Platform.OS === "ios" && insets.top > 47

  // Check if the screen is large (commonly used for adapting UI for tablets)
  const isLargeScreen = width >= 768
  const isSmallScreen = width <= 375 // SE or smaller phones
  const isIos = Platform.OS === "ios"
  const isAndroid = Platform.OS === "android"
  const isWeb = Platform.OS === "web"

  return {
    hasNotch,
    isLargeScreen,
    isIos,
    isAndroid,
    isWeb,
    isSmallScreen,
    screenWidth: width,
    screenHeight: height,
  }
}

export default useDeviceAttributes
